import React from "react";
import Modal from "../../../../components/Modal";

export function SubnetScanOverlayModal({
  activeScanSubnet,
  scanProgress = 0,
  scanTerminalLines = [],
  scanTerminalBottomRef,
  scanResultSummary,
  scanFinished = false,
  onClose,
  onDone,
}) {
  if (!activeScanSubnet) return null;

  return (
    <Modal
      title={`Autodiscover Assets — ${activeScanSubnet.subnet}`}
      onClose={() => {
        if (scanFinished) onClose();
        else if (window.confirm("Scan in progress. Exit modal?")) onClose();
      }}
      width={600}
    >
      <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
        <div style={{ fontSize: 13, color: "#4B5563" }}>
          Active sweep on: <strong>{activeScanSubnet.subnet}</strong> (
          {activeScanSubnet.name})
        </div>

        {/* Progress */}
        <div
          style={{
            height: 6,
            background: "#E5E7EB",
            borderRadius: 4,
            overflow: "hidden",
          }}
        >
          <div
            style={{
              width: `${scanProgress}%`,
              height: "100%",
              background: "linear-gradient(90deg, #1D4ED8, #7C3AED)",
              transition: "width 0.25s ease",
            }}
          />
        </div>

        {/* Logs screen */}
        <div
          style={{
            height: 220,
            background: "#0F172A",
            borderRadius: 8,
            padding: 14,
            overflowY: "auto",
            fontFamily: "monospace",
            fontSize: 12,
            color: "#10B981",
            lineHeight: 1.6,
          }}
        >
          {scanTerminalLines.map((line, i) => {
            let color = "#34D399";
            if (line.type === "cmd") color = "#60A5FA";
            else if (line.type === "new") color = "#F59E0B";
            else if (line.type === "dim") color = "#475569";
            else if (line.type === "error") color = "#EF4444";
            return (
              <div key={i} style={{ color, marginBottom: 2 }}>
                {line.t}
              </div>
            );
          })}
          <div ref={scanTerminalBottomRef} />
        </div>

        {scanResultSummary && (
          <div
            style={{
              padding: "10px 14px",
              background: "#F0FDF4",
              borderRadius: 6,
              color: "#15803D",
              fontSize: 13,
              fontWeight: 600,
              border: "1px solid #DCFCE7",
            }}
          >
            {scanResultSummary}
          </div>
        )}

        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            borderTop: "1px solid #F3F4F6",
            paddingTop: 14,
          }}
        >
          <button
            disabled={!scanFinished}
            onClick={onDone}
            style={{
              padding: "8px 16px",
              background: scanFinished ? "#1D4ED8" : "#BFDBFE",
              color: "#fff",
              border: "none",
              borderRadius: 6,
              fontSize: 13,
              fontWeight: 600,
              cursor: scanFinished ? "pointer" : "not-allowed",
            }}
          >
            Done
          </button>
        </div>
      </div>
    </Modal>
  );
}

export default SubnetScanOverlayModal;
